var mrForm = {
    data: {},
    html: null,
    code: null,
    params: [],
    page: 1,
    change: [],
    delete: [],
    updated: false,
    formChange: false,
    opened: false,
    selectA: [],
    itemInit: [],
    init: function (params) {
        this.code = params.code;
        if (typeof params.params == "Array") this.params = params.params;
        else this.params = params.params.split(":");
        this.updated = false;
        this.formChange = false;
        if (params.e) e.stopPropagation();
        if (params.data) {
            this.data = params.data;
            this.open();
        } else this.loadData();
    },
    loadData: function (pDataOnly) {
        var self = this, vDataOnly = "N";
        if (pDataOnly) vDataOnly = "Y";
        lxLoad();
        $.ajax({
            url: "wwv_flow.show",
            dataType: "json",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=multirow",
                x01: self.code,
                x02: self.page,
                x03: self.params.join(":"),
                x04: self.search,
                x05: self.searchCol,
                x06: vDataOnly
            },
            success: function (d) {
                lxLoadRemove();
                if (d.ERR) alert(d.ERR);
                else {
                    if (pDataOnly) {
                        self.data.rows = d.rows;
                        self.data.records = d.records;
                    }
                    else self.data = d;
                    self.open();
                }
            }
        });
    },
    refresh: function () {
        if ((this.change.length > 0 || this.delete.length > 0) && confirm("Apply changes?")) this.submit();
        else {
            this.loadData(true);
            this.change = [];
        }
    },
    genPagination: function () {
        var records = this.data.records, recPerPage = this.data.recPerPage, pages = Math.ceil(records / recPerPage);
        var min = 1, max = pages, buffer = 10;
        var pagination = '';
        if (this.page != 1) pagination += '<span onclick="mrForm.setPage(1)" title="First Page"><<</span>'
            + '<span onclick="mrForm.setPage(' + (this.page - 1) + ')" title="Previous Page"><</span>';
        if (this.page > buffer && this.page < (this.data.gen)) {
            min = this.page - buffer;
            max = this.page + buffer;
        } else if (this.page <= buffer && pages > (2 * buffer)) max = 2 * buffer;
        else if (this.page >= (pages - buffer) && pages > (2 * buffer)) min = pages - (2 * buffer);

        for (var i = min; i <= max; i++) {
            if (i == this.page) pagination += '<span class="lxIrCurrentPg">' + i + '</span>';
            else pagination += '<span onclick="mrForm.setPage(' + i + ');">' + i + '</span>';
        }
        if (this.page != pages) pagination += '<span onclick="mrForm.setPage(' + (this.page + 1) + ')" title="Next Page">></span>'
            + '<span onclick="mrForm.setPage(' + pages + ')" title="Last Page">>></span>';
        pagination = '<div class="lxIrPagination">Page:&nbsp;&nbsp;' + pagination + ' | Total Records: ' + records + '</div>';
        return pagination;
    },
    setPage: function (params) {
        this.page = params;
        this.refresh();
    },
    setParam: function (params) {
        //this.params[params.index] = params.value;
        var $vItem = $(params), paramIndex = $vItem.closest(".mrFilter").attr("param");
        this.params[paramIndex] = $vItem.val();
        this.refresh();
    },
    open: function () {
        var self = this;
        var formHtml = '', filter = '', vInfo = '', lxForm = '', tblLegend = '', rows = [];
        // Columns
        for (var i = 0; i < self.data.col.length; i++) {
            if (self.data.col[i].type != 'H' && self.data.col[i].type != 'ID' && self.data.col[i].type != 'CLASS')
                formHtml += '<th class="a-IRR-header u-tL">' + (self.data.col[i].name ? self.data.col[i].name : '') + '</th>';
        }
        // generate rows
        if (self.data.rows.length > 0)
            for (var i = 0; i < self.data.rows.length; i++)
                rows.push(self.addRow(self.data.rows[i]));
        // multirow form
        formHtml = '<div class="vsmMultirow"' + ((this.data.gen.width) ? ' style="width:' + (this.data.gen.width - 30) + 'px;margin-left:auto;margin-right:auto"' : '')
            + '><div class="hdr"><div class="title">' + this.data.gen.title
            + '</div><div class="btnContainer">'
            + ((self.data.gen.open == "slideIn" || self.data.gen.open == "popUp") ? '<div class="m-btn blue mini" onclick="mrForm.close();">Close</div>' : '')
            + (self.data.gen.updateOnly ? '' : '<div class="t-Button t-Button--icon t-Button" onclick="mrForm.addRow();">Add Row</div>')
            + ((self.data.gen.open != "render") ? '<div class="t-Button t-Button--icon t-Button" onclick="mrForm.submit();">Apply Changes</div>' : '')
            + '</div></div><div class="cont">' + vInfo + filter + lxForm
            + '<div>' + tblLegend
            + '<table class="a-IRR-table" style="margin-top: 1.6rem;margin-bottom: 1.6rem;"><thead><tr>'
            + formHtml
            + '</tr></thead><tbody>'
            + rows.join("") + '</tbody></table></div>'
            + self.genPagination()
            + '</div></div>';
        self.html = formHtml;
        //alert(1);
        if (self.data.gen.open == "slideIn") self.slideIn();
        else if (self.data.gen.open == "popUp") self.openPopup();
        else if (self.data.gen.open == "render") $("#mr" + self.code).html(self.html);
        else $("#mr" + self.code).html(self.html);
        //alert(2);
        self.opened = true;

        self.jsItemInit();
    },
    close: function () {
        var self = this;
        if ((this.change.length > 0 || this.delete.length > 0 || this.formChange) && confirm("Submit changes?"))
            this.submit(true);
        else {
            this.change = [];
            this.delete = [];
            this.formChange = false;
            if (self.data.gen.open == "slideIn") self.slideOut();
            else if (self.data.gen.open == "popUp") self.closePopup();
            else $("#mr" + self.code).html("");
            if (self.updated) self.refreshCallback();
            self.opened = false;
            apex.message.clearErrors();
            $x_Remove('uSuccessMessage');
        }
    },
    slideIn: function () {
        var self = this;
        if (!self.opened) {
            // if closed slide in the form
            $('<div class="vsmMultirowSlide" style="display:none;">' + self.html + '</div>').insertAfter(".ui-center");
            $(".ui-center").hide("slide", { direction: "left" }, self.slideSpeed, function () {
                $(".vsmMultirowSlide").show("slide", { direction: "right" }, self.slideSpeed);
                //$('html, body').animate({scrollTop: $(".vsmBtn" + searchProfileType).offset().top - 70}, 10);
            });
        } else $(".vsmMultirow").replaceWith(self.html); // already open just replace content
    },
    slideOut: function () {
        var self = this;
        $(".vsmMultirowSlide").hide("slide", { direction: "right" }, self.slideSpeed, function () {
            $(".ui-center").show("slide", { direction: "left" }, self.slideSpeed);
            $(".vsmMultirowSlide").remove();
        });
    },
    openPopup: function () {
        var self = this;
        if (!self.opened) {
            $('<div class="vsmMultirowPopup">' + this.html + '</div>').dialog({
                modal: true,
                resizable: false,
                title: "",
                width: self.data.gen.width,
                close: function (event, ui) {
                    self.close();
                }
            });
        } else $(".vsmMultirow").replaceWith(self.html); // already open just replace content
        // fix for select2 search
        $.ui.dialog.prototype._allowInteraction = function (e) { return true; };
    },
    closePopup: function () {
        $(".vsmMultirowPopup").dialog("destroy");
    },
    addRow: function (params) {
        var vRet = "", vTemp, vHidden = "", vData = false, vValue, vDate = false, vSelect = false, vSelectA, vCascade, vRowClass = '', vWidth, vType;
        if (params) vData = true;
        // iterate items
        for (var i = 0; i < this.data.col.length; i++) {
            var vId = this.data.col[i].id;
            vTemp = "";
            // set item value
            if (this.data.col[i].type != 'DEL')
                if (vData) vValue = params[vId];
                else vValue = (this.data.col[i].def == 'PARAM') ? this.params[this.data.col[i].defParam] : this.data.col[i].def;
            // set item width if specified
            if (this.data.col[i].width) vWidth = 'width:' + this.data.col[i].width + 'px;';
            else vWidth = '';
            // check row modifier for item type
            if (vData && this.data.col[i].type != 'DEL') {
                if (typeof params[vId].mod === 'undefined' || params[vId].mod == null) v_type = this.data.col[i].type;//
                else if (params[vId].mod == "H") v_type = "E";
                else v_type = this.data.col[i].type;
            } else {
                v_type = this.data.col[i].type;
            }
            // generate item based on his type
            switch (v_type) {
                // Hidden item
                case "H": vHidden += '<input type="hidden" name="' + this.data.col[i].id + '" value="' + vValue + '" />';
                    break;
                // Hidden item
                case "E": vTemp += '<input type="hidden" name="' + this.data.col[i].id + '" value="' + vValue + '" />';
                    break;
                // Number item
                case "N": vTemp = '<input type="text" name="' + this.data.col[i].id + '" value="' + vValue + '" style="text-align:right;' + vWidth + '" />';
                    break;
                // Text item
                case "T": vTemp = '<input type="text" name="' + this.data.col[i].id + '" value="' + vValue + '"' + (vWidth ? ' style="' + vWidth + '"' : '') + ' />';
                    break;
                // Text area item
                case "TA": vTemp = '<textarea rows="1" name="' + this.data.col[i].id + '" style="height:20px;' + vWidth
                    + '">' + vValue + '</textarea>';
                    break;
                // Date Item
                case "D": vTemp = '<input type="text" name="' + this.data.col[i].id + '" value="' + vValue + '" class="vsmMrDate" />';
                    vDate = true;
                    break;
                // Select item
                case "S": vTemp = '<input type="text" class="vsmMrSelect" id="' + this.data.col[i].id + '" value="' + vValue + '" style="width:100%"" />';
                    break;
                // Select AJAX item
                /*case "SA": vTemp = '<input type="text" class="vsmMrSelectA" id="' + this.data.col[i].id + '" value="' + vValue + '" style="width:100%"" />';
                    break;*/
                // Select item
                case "SM": vTemp = '<input type="text" class="vsmMrSelectM" name="' + this.data.col[i].id + '" value="' + vValue + '" style="width:100%" />';
                    /*var vSelected;
                    var vLov = (Array.isArray(this.data.col[i].lov)) ? this.data.col[i].lov : this.data.gen.lov[this.data.col[i].lov];
                    for (var o = 0; o < vLov.length; o++) {
                        vSelected = false;
                        for (var v = 0; v < vValue.length; v++) {
                            if (vValue[v] == vLov[o].id)
                                vSelected = true;
                        }
                        vTemp += '<option value="' + vLov[o].id + '"'
                            + (vSelected ? ' selected' : '') + '>'
                            + vLov[o].text + '</option>';

                    }
                    vTemp = '<select class="vsmMrSelect" name="' + this.data.col[i].id + '"' + (vWidth ? ' style="' + vWidth + '"' : '') + ' multiple="multiple">' + vTemp
                        + '</select>';
                    vSelect = true;*/
                    break;
                // Checkbox item
                case "C": vTemp = '<input type="checkbox" name="' + this.data.col[i].id + '" value="' + this.data.col[i].options[0].r
                    + '"' + ((this.data.col[i].options[0].r == vValue) ? ' checked="checked"' : '')
                    + '" />';
                    break;
                // row class
                case "CLASS": vRowClass = ' class="' + vValue + '"';
                    break;
                // delete row item
                case "DEL": vTemp = '<div class="vsmMrDelete" onclick="mrForm.delRow(this);"><i class="fas fa-trash" style="font-size: 14px;'
                    + '"></i></div>';
                    break;
                default: null;
            }

            if (vTemp != "") {
                vRet += '<td>' + vTemp + vHidden + '</td>';
                vHidden = "";
            }

        }

        if (vData) {
            return '<tr rowid="' + (vData ? params['f01'] : this.data.col[0].def - this.change.length) + '" onchange="mrForm.rowChange(this);"' + vRowClass + '>' + vRet + '</tr>';
        } else {
            $(".vsmMultirow table > tbody").prepend('<tr rowid="' + (vData ? params['f01'] : this.data.col[0].def - this.change.length) + '" onchange="mrForm.rowChange(this);"' + vRowClass + '>' + vRet + '</tr>');
            this.jsItemInit({ new: true });
            this.rowChange($(".vsmMultirow table > tbody tr:first-child"));
        }
    },
    jsItemInit: function (params) {
        var self = this;
        var vSelector = '.vsmMultirow ';
        if (params && params.new) vSelector += ' table > tbody tr:first-child ';
        for (var i = 0; i < self.data.col.length; i++) {
            switch (self.data.col[i].type) {
                case 'S': var vLov = (Array.isArray(self.data.col[i].lov)) ? self.data.col[i].lov : self.data.gen.lov[self.data.col[i].lov];
                    $(vSelector + "input[name=" + self.data.col[i].id + "]").select2({ data: vLov });
                    break;
                case 'SM': var vLov = (Array.isArray(self.data.col[i].lov)) ? self.data.col[i].lov : self.data.gen.lov[self.data.col[i].lov];
                    $(vSelector + "input[name=" + self.data.col[i].id + "]").select2({ data: vLov, multiple: true });
                    break;
                case 'D': $(vSelector + " input[name=" + self.data.col[i].id + "]").datepicker({ dateFormat: 'mm/dd/yy' });//translation.date_format
            }
        }
    },
    rowChange: function (params) {
        var rowData = [],
            $row = $(params),
            pushRow = true;

        rowData.push($row.attr("rowid"));
        for (var i = 0; i < this.data.col.length; i++) {
            switch (this.data.col[i].type) {
                case "H": rowData.push($row.find('input[name=' + this.data.col[i].id + ']').val().replace("|", "").replace("~", ""));
                    break;
                case "N": rowData.push($row.find('input[name=' + this.data.col[i].id + ']').val().replace("|", "").replace("~", ""));
                    break;
                case "T": rowData.push($row.find('input[name=' + this.data.col[i].id + ']').val().replace("|", "").replace("~", ""));
                    break;
                case "TA": rowData.push($row.find('textarea[name=' + this.data.col[i].id + ']').val().replace("|", "").replace("~", ""));
                    break;
                case "D": rowData.push($row.find('input[name=' + this.data.col[i].id + ']').val());
                    break;
                case "S": rowData.push($row.find('input[name=' + this.data.col[i].id + ']').val());
                    break;
                /*case "SA": rowData.push($row.find('select[name=' + this.data.col[i].id + ']').val());
                    break;*/
                case "SM": rowData.push($row.find('input[name=' + this.data.col[i].id + ']').select2("val"));//.join(":")
                    break;
                case "C": rowData.push($row.find('input[name=' + this.data.col[i].id + ']:checked').val());
                    break;
                default: null;
            }
        }

        for (var j = 0; j < this.change.length; j++) {
            if (this.change[j][0] == rowData[0]) {
                this.change[j] = rowData;
                pushRow = false;
            }
        }

        if (pushRow) this.change.push(rowData);

        $(".mrSave").addClass("red");
    },
    delRow: function (params) {
        var $row = $(params).closest("tr"),
            rowid = $row.attr("rowid");
        this.delete.push(rowid);
        $row.remove();
        if (this.data.gen.deleteItem) $s(this.data.gen.deleteItem, this.delete.join(':'));

        for (var j = 0; j < this.change.length; j++) {
            if (this.change[j][0] == rowid) this.change.splice(j, 1);
        }

        $(".mrSave").addClass("red");
    },
    refreshCallback: function () {
        //alert(this.code);
        var self = this;
        if (self.code == 'TASK_MEMBER') {
            if ($("#gantt_container").length == 1) {
                refreshTask(self.params[0], true);
            } else {
                lxTaskList(self.data.gen.projectId, self.params[0]);
            }
        }
    },
    submit: function (params) {
        var self = this;
        var lData = [];
        var lFormData = [];
        var lErr = false;

        for (var j = 0; j < this.change.length; j++) {
            lData.push(this.change[j].join('~'));
        }

        if (self.formChange) {
            for (var i = 0; i < self.data.gen.form.item.length; i++) {
                lFormData.push(getLxItemVal({ "id": "lxForm" + i, "type": self.data.gen.form.item[i].type }));
            }
        }

        /*$(".vsmMultirow tbody tr").each(function () {
            var fname = $(this).find("input[name=inv_fname]").val().replace("|", "").replace("~", "");
            var lname = $(this).find("input[name=inv_lname]").val().replace("|", "").replace("~", "");
            var email = $(this).find("input[name=inv_email]").val().replace("|", "").replace("~", "");
            lRow = fname +"|"+ lname +"|"+ email +"|"+ $(this).find("input[name=inv_ius]").val();
            
            if (lRow != "|||" && lRow != "|||undefined") {
                if (fname != "" && email != "") lData.push(lRow);
                else lErr = true;
            }
            
        });
        if (lErr || lData.length == 0) {alert("First Name and Email are mandatory fields!");return;}*/
        lxLoad();
        apex.server.process("multirowSubmit", {
            x01: self.code,
            x02: self.page,
            x03: self.params.join(":"),
            x04: self.search,
            x05: self.searchCol,
            x06: lData.join("|"),
            x07: self.delete.join(":"),
            x08: lFormData.join("|")
        }, {
                dataType: "json",
                success: function (d) {
                    apex.message.clearErrors();
                    if (d.msg) {
                        if (self.data.gen.open == "popUp") alert(d.msg);
                        else apex.message.showErrors([{ type: "error", location: ["page"], message: d.msg, unsafe: false }]);
                    }
                    if (d.err) {
                        if (self.data.gen.open == "popUp") alert(d.err);
                        else apex.message.showErrors([{ type: "error", location: ["page"], message: d.err, unsafe: false }]);
                    } else if (params) {
                        self.updated = true;
                        self.change = [];
                        self.delete = [];
                        self.formChange = false;
                        self.close();
                    } else {
                        self.updated = true;
                        self.change = [];
                        self.delete = [];
                        self.formChange = false;
                        self.data.rows = d.rows;
                        self.data.records = d.records;
                        if (d.info) self.data.gen.info = d.info;
                        if (d.formData) self.data.gen.formData = d.formData;
                        self.open();
                        if (!d.msg) {
                            if (self.data.gen.open != "popUp") apex.message.showPageSuccess("Changes saved.");
                        }
                    }
                    lxLoadRemove();
                }
            });
    }


}